import moment from 'moment'

const errorFeedbacks = {
  required: 'This field is required',
  positiveNumber: 'This field requires a positive number',
  latlon: 'This field required command separated pair of lat and lon',
  dateRequired: 'This field is required when using comparison',
  comparisonRequired: 'This field is required to compare date ranges',
  numberBetweenZeroAndHundred: 'This requires a number between 0 and 100',
  dateInValidFormat: 'Please enter a valid date in year-month-date format. For example 2018-12-01.',
  validatePhqAttendanceOptional: 'This optional field requires a positive number'
}

const BaseRules = {
  required: (value) => {
    return !(!value || value.length === 0)
  },
  positiveNumber: (value) => {
    return !(isNaN(value) || value <= 0)
  },
  latlon: (value) => {
    let asArray = value.split(',')
    let containsNonNumbers = asArray.some((elem) => isNaN(elem))
    return asArray.length === 2 && !containsNonNumbers
  },
  // TODO Would be better to have baseRules and field rules
  // definitions to support rule arguments if there more fields like this
  numberBetweenZeroAndHundred: (value) => {
    return value ? !(isNaN(value) || value > 100 || value < 0) : true
  },
  dateInValidFormat: (value) => {
    return moment(value, 'YYYY-M-DD', true).isValid()
  }
}

const FieldRules = {
  'validatePhqAttendanceOptional': (value) => {
    // The value is undefined before the form field is used, and may be blank.
    return value === undefined || value === '' || BaseRules.positiveNumber(value)
  }
}

const DateFieldsValidations = {
  threshold_one: ['required', 'dateInValidFormat'],
  comparison_one: ['required'],
  threshold_two: ['required', 'dateInValidFormat'],
  comparison_two: ['required']
}

const Fields = {
  filterSelect: {
    type: ['required']
  },
  country: {
    countries: ['required']
  },
  category: {
    categories: ['required']
  },
  label: {
    labels: ['required']
  },
  query: {
    query: ['required']
  },
  rank: {
    ranks: ['required']
  },
  'local-rank': {
    local_ranks: ['required']
  },
  'aviation-rank': {
    aviation_ranks: ['required']
  },
  'rank-range': {
    threshold_one: ['required', 'numberBetweenZeroAndHundred'],
    comparison_one: ['required'],
    threshold_two: ['numberBetweenZeroAndHundred']
  },
  'local-rank-range': {
    threshold_one: ['required', 'numberBetweenZeroAndHundred'],
    comparison_one: ['required'],
    threshold_two: ['numberBetweenZeroAndHundred']
  },
  'aviation-rank-range': {
    threshold_one: ['required', 'numberBetweenZeroAndHundred'],
    comparison_one: ['required'],
    threshold_two: ['numberBetweenZeroAndHundred']
  },
  'phq-attendance': {
    threshold_one: ['required', 'positiveNumber'],
    comparison_one: ['required'],
    threshold_two: ['validatePhqAttendanceOptional'] // a FieldRule
  },
  state: {
    states: ['required']
  },
  place: {
    type: ['required'],
    places: ['required']
  },
  within: {
    unit: ['required'],
    radius: ['required', 'positiveNumber'],
    latlon: ['required', 'latlon']
  },
  active: DateFieldsValidations,
  start: DateFieldsValidations,
  end: DateFieldsValidations,
  updated: DateFieldsValidations
}

const comparisonFilters = [
  'aviation-rank-range',
  'local-rank-range',
  'phq-attendance',
  'rank-range'
]

export const validateFields = (filterForm) => {
  let errors = {}
  let formType = filterForm.type
  let rules = Fields[formType]
  for (let [field, fieldRules] of Object.entries(rules)) {
    for (let rule of fieldRules) {
      let isFieldValid = false
      if (rule in BaseRules) {
        isFieldValid = BaseRules[rule](filterForm.values[field])
      } else {
        isFieldValid = FieldRules[rule](filterForm.values[field])
      }
      if (!isFieldValid) {
        errors[field] = {
          invalidFeedback: errorFeedbacks[rule]
        }
        break
      }
    }
  }
  if (comparisonFilters.includes(formType)) {
    if (filterForm.values.threshold_two && !filterForm.values.comparison_two) {
      errors.comparison_two = { invalidFeedback: 'This field is required when second threshold is set.' }
    } else if (!filterForm.values.threshold_two && filterForm.values.comparison_two) {
      errors.threshold_two = { invalidFeedback: 'This field is required when second comparison is set.' }
    }
  }
  return errors
}
